import {Duration, DurationType} from "../../utils";
import {useState} from "react";

function durationTypDisplay(amount: string, type: DurationType) {
    const singular = amount === '1'
    switch (type) {
        case 'MINUTES': {
            return singular ? 'Minute' : 'Minuten';
        }
        case 'HOURS': {
            return singular ? 'Stunde' : 'Stunden';
        }
        case 'DAYS': {
            return singular ? 'Tag' : 'Tage';
        }
    }
}

interface FieldDurationProps {
    value?: Duration
    id?: string
    required?: boolean
    label?: string
    disabled?: boolean
    onChange: (value: Duration | undefined) => void
    onBlur?: () => Promise<any>
}


function FieldDuration({
                           value,
                           id,
                           label,
                           disabled,
                           required,
                           onBlur,
                           onChange
                       }: FieldDurationProps) {
    const [lastValidDurationType, setLastValidDurationType] = useState<DurationType | undefined>(undefined)
    const relDurationType = value?.type || lastValidDurationType
    const relValue = value ? `${value.value}` : ''

    return <>

        <label
            id={id}
            className={`field ${required ? 'required' : ''}`}
        >
            {label && <label className={`label`}>{label}</label>}
            <div className={`field has-addons`}>
                <div className="control">
                    <span className="select">
                        <select
                            disabled={disabled}
                            onChange={e => {
                                const s = e.target.value as DurationType
                                const val = parseInt(relValue || '0', 10)
                                if (s) {
                                    setLastValidDurationType(s)
                                }

                                val && onChange && onChange({
                                    value: val,
                                    type: s
                                })
                            }}
                            onBlur={() => onBlur && onBlur()}
                            value={relDurationType}
                            style={{
                                width: '7em'
                            }}
                        >
                            {!relDurationType && <option
                                value={undefined}></option>}
                            <option
                                value={'DAYS'}>{durationTypDisplay(relValue || '', 'DAYS')}</option>
                            <option
                                value={'HOURS'}>{durationTypDisplay(relValue || '', 'HOURS')}</option>
                            <option
                                value={'MINUTES'}>{durationTypDisplay(relValue || '', 'MINUTES')}</option>
                        </select>
                    </span>
                </div>
                <div className="control">
                    <input
                        disabled={disabled}
                        className="input"
                        type={'number'}
                        min={0}
                        value={relValue}
                        onBlur={() => onBlur && onBlur()}
                        onChange={e => {
                            if (relDurationType) {
                                const s = relDurationType
                                const val = e.target.value
                                onChange && onChange(val ? {
                                    type: s,
                                    value: parseInt(e.target.value || '0', 10)
                                } : undefined)
                            }
                        }}
                    />
                </div>
            </div>
        </label>
    </>
}

export {
    FieldDuration
}
